<div>
  <ng-container *ngIf="(showLoadingReplacingActivities$ | async) === false; else loading">
    <ng-container *ngIf="activitySections$ | async as activitySections">
      <ng-container *ngIf="activitySections.length > 0; else emptyActivities">
        <div class="section-container" *ngFor="let section of activitySections; trackBy: trackActivitySectionsBy">
          <div class="section-header-container">
            <h2 class="section-header-text">{{ section.name | translate }}</h2>
          </div>
          <ng-container *ngIf="crmIdentifiers$ | async as crmIdentifier">
            <ng-container *ngFor="let activity of section.activities; trackBy: trackActivitiesBy; let last = last">
              <ng-container *ngIf="activity.isLoggedActivity; else systemActivity">
                <div
                  *ngIf="isActivityValid(activity)"
                  [ngSwitch]="activity.crmObjectSubtype"
                  class="activity-card"
                  [ngClass]="{ 'last-activity-card': last }"
                >
                  <ng-template #taskSubtitle>
                    <ng-container
                      *ngTemplateOutlet="
                        (activity | crmIsTaskOverdue) ? taskOverdueSubtitle : taskDueSubtitle;
                        context: { activity }
                      "
                    ></ng-container>
                  </ng-template>
                  <crm-activity-template
                    [activity]="activity"
                    [ownerUser]="activity.ownerUser"
                    [isOwnedByServiceAccount]="activity.ownerId === ''"
                    [subtitleTemplate]="activity.crmObjectSubtype === 'Task' ? taskSubtitle : undefined"
                  >
                    <ng-container *ngIf="!editingActivities[activity.crmObjectId!]">
                      <ng-container [ngSwitch]="activity.crmObjectSubtype">
                        <crm-activity-logged-note
                          *ngSwitchCase="'Note'"
                          [activity]="activity"
                        ></crm-activity-logged-note>
                        <crm-activity-logged-email
                          *ngSwitchCase="'Email'"
                          [activity]="activity"
                        ></crm-activity-logged-email>
                        <crm-activity-logged-call
                          *ngSwitchCase="'Call'"
                          [activity]="activity"
                        ></crm-activity-logged-call>
                        <crm-activity-logged-meeting
                          *ngSwitchCase="'Meeting'"
                          [activity]="activity"
                        ></crm-activity-logged-meeting>
                        <crm-activity-task
                          *ngSwitchCase="'Task'"
                          [activity]="activity"
                          (activityChange)="updateActivity($event)"
                          [associatedObject]="crmIdentifier"
                          [users]="uniqueUsers$ | async"
                        ></crm-activity-task>
                        <crm-activity-logged-communication
                          *ngSwitchCase="'Communication'"
                          [activity]="activity"
                        ></crm-activity-logged-communication>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="editingActivities[activity.crmObjectId!]">
                      <crm-activity-logger
                        *ngIf="activity | crmTimelineAssociatedObject: crmIdentifier as crmActivity"
                        crm-activity-template-edit
                        [crmObjectId]="crmActivity.crmObjectId"
                        [objectType]="crmActivity.objectType"
                        [crmActivityId]="activity.crmObjectId!"
                        [expandAndSelectType]="activity.crmObjectSubtype"
                        [hideAssociations]="crmIdentifier.objectType === 'Opportunity'"
                        [activityOwner]="activity.ownerUser"
                        (cancel)="editingActivities[activity.crmObjectId!] = false"
                        (activityUpdated)="updateActivity($event)"
                      ></crm-activity-logger>
                    </ng-container>

                    <crm-association-popover
                      [activity]="activity"
                      [associatedObject]="crmIdentifier"
                    ></crm-association-popover>

                    <div
                      class="activity-options-menu"
                      crmActivityTemplateOptions
                      *ngIf="!editingActivities[activity.crmObjectId!]"
                    >
                      <mat-menu #activityOptionsMenu="matMenu">
                        <button mat-menu-item (click)="editingActivities[activity.crmObjectId!] = true">
                          {{ 'ACTIVITY.MENU.EDIT' | translate }}
                        </button>
                      </mat-menu>
                      <button mat-icon-button [matMenuTriggerFor]="activityOptionsMenu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </div>
                  </crm-activity-template>
                </div>
              </ng-container>
              <ng-template #systemActivity>
                <div
                  *ngIf="isActivityValid(activity)"
                  [ngSwitch]="activity.crmObjectSubtype"
                  class="activity-card"
                  [ngClass]="{ 'last-activity-card': last }"
                >
                  <crm-activity-record-change
                    [activity]="activity"
                    *ngSwitchCase="'RecordChange'"
                  ></crm-activity-record-change>
                  <crm-activity-note *ngSwitchCase="'Note'" [activity]="activity"></crm-activity-note>
                  <crm-activity-email
                    *ngSwitchCase="'Email'"
                    [activity]="activity"
                    [associatedObjectId]="crmIdentifier.crmObjectId"
                    [objectType]="crmIdentifier.objectType"
                  ></crm-activity-email>
                  <crm-activity-call
                    *ngSwitchCase="'Call'"
                    [activity]="activity"
                    [associatedObjectId]="crmIdentifier.crmObjectId"
                    [objectType]="crmIdentifier.objectType"
                  ></crm-activity-call>
                  <crm-activity-communication
                    *ngSwitchCase="'Communication'"
                    [activity]="activity"
                  ></crm-activity-communication>
                  <crm-activity-opportunity-updated
                    *ngSwitchCase="'OpportunityChange'"
                    [activity]="activity"
                  ></crm-activity-opportunity-updated>
                </div>
              </ng-template>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="showLoadingAfterActivities$ | async">
        <glxy-loading-spinner></glxy-loading-spinner>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>

<ng-template #emptyActivities>
  <ng-container *ngIf="{ filtersPristine: filtersPristine$ | async } as filtersPristineObj">
    <ng-container *ngIf="(loading$ | async) === false">
      <glxy-empty-state class="empty-state-container">
        <glxy-empty-state-hero>
          <img
            src="https://storage.googleapis.com/galaxy-libs-public-images/crm/activities-empty-state-v2.svg"
            [alt]="'CONTACT.ACTIVITIES_TIMELINE.EMPTY.IMAGE_ALT' | translate"
          />
        </glxy-empty-state-hero>
        <ng-container *ngIf="filtersPristineObj.filtersPristine; else emptyActivitiesSearchText">
          <glxy-empty-state-title>
            {{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY.HEADER' | translate }}
          </glxy-empty-state-title>
          <p>{{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY.HINT' | translate }}</p>
        </ng-container>
        <ng-template #emptyActivitiesSearchText>
          <glxy-empty-state-title>
            {{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY_SEARCH.HEADER' | translate }}
          </glxy-empty-state-title>
          <p>{{ 'CONTACT.ACTIVITIES_TIMELINE.EMPTY_SEARCH.HINT' | translate }}</p>
        </ng-template>
      </glxy-empty-state>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #taskDueSubtitle let-activity="activity">
  <div>{{ 'ACTIVITY.DUE' | translate }}: {{ activity | crmActivityEffectiveDate | date: dateFormat }}</div>
</ng-template>

<ng-template #taskOverdueSubtitle let-activity="activity">
  <div class="activity-overdue-subtitle">
    <mat-icon>alarm</mat-icon>
    <span>{{ 'ACTIVITY.OVERDUE' | translate }}: {{ activity | crmActivityEffectiveDate | date: dateFormat }}</span>
  </div>
</ng-template>
